<script>
import Vue from "vue";
export default {
  name: "SvgPreview",
  props: {
    colors: { type: Array, default: null },
    svg: { type: String, default: null }
  },
  data() {
    return {
      msg: "Hello",
      template: null
    };
  },
  watch: {
    svg: function() {
      self.template = Vue.compile(
        '<div style="width:100%">' + self.svg + "</div>"
      ).render;
    }
  },
  mounted() {
    var self = this;
    setTimeout(function() {
      self.template = Vue.compile("<div>" + self.svg + "</div>").render;
    }, 5000);
  },
  render: function(createElement) {
    if (!this.template) {
      return createElement(
        "div",
        {
          attrs: {
            "uk-spinner": "ratio: 3",
            class: "uk-margin-large uk-margin-large-top"
          }
        },
        " "
      );
    } else {
      return this.template();
    }
  }
};
</script>

<style type="text/css"></style>



// WEBPACK FOOTER //
// src/components/SvgPreview.vue